import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Wrapper } from 'src/app/components/wrapper.component';
import { JoiEvent, MediaTerms } from 'globals/store/events.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { MediaTermState, Performer } from 'globals/store/performers.data';
import { JoiResource } from 'globals/store/resources.data';
import { entityMediaTermsReselector } from '../../store/reselectors/entity.reselector';
import { AddLinkToBriefComponent } from 'src/app/components/wrappers/add-link-to-brief-wrapper.component';
import { CommonModule, UpperCasePipe } from '@angular/common';

@Component({
    selector: 'manage-terms',
    template: `
<ng-container *ngFor="let terms of mediaTerms">
  <h5 class="subtitle" style="padding-top: 30px;">{{ terms.name | uppercase }}</h5>
  <div *ngIf="!terms.use" class="empty-text">{{ terms.name }} are currently turned off. Go to <strong>configure</strong> then <strong>brief information</strong> to turn on.</div>
  <add-link-to-brief-wrapper *ngIf="terms.use"
    [title]="'Include <strong>'+ terms.name +' acceptance</strong> in ' + type + ' brief for ' + entity.name + '?'"
    [toggleOn]="!entity.noTermsMap[terms.id]"
    [statusOptions]="mediaTermChoices"
    [disabled] = "readOnly"
    [selected] = "entity.mediaTermsMap[terms.id] || 'Not Accepted'"
    (toggle)="toggleMediaTermsRequired(terms)"
    (toggleStatus)="setMediaTerms($event, terms)"
  ></add-link-to-brief-wrapper>
</ng-container>
`,
    standalone: true,
    imports: [AddLinkToBriefComponent, CommonModule, UpperCasePipe],
})
export class ManageTermsComponent extends Wrapper<ManageTermsComponent> implements OnInit {
  @Input() type: 'performer' | 'exhibitor' | 'resource' | 'attendee' = 'performer'
  @Input() readOnly = true
  @Input() entity: Performer | Exhibitor | JoiResource
  @Output() saveEntity: EventEmitter<void> = new EventEmitter()

  mediaTermChoices: MediaTermState[] = ['Not Accepted', 'Accepted']  
  event: JoiEvent
  mediaTerms: MediaTerms[] = []

  constructor() {
    super()
    this.subProp(this.store.select('events', 'event'), 'event')
  }

  ngOnInit() {
    this.selectProp(entityMediaTermsReselector, { type: this.type, id: this.entity.id }, 'mediaTerms')
  }
    
  toggleMediaTermsRequired(terms: MediaTerms) {
    this.entity.noTermsMap[terms.id] = !this.entity.noTermsMap[terms.id]
    this.saveEntity.emit()
  }

  setMediaTerms(mediaTerms: string, terms: MediaTerms) {
    this.entity.mediaTermsMap[terms.id] = mediaTerms as MediaTermState
    console.log({ entity: this.entity, mediaTerms, terms })

    this.saveEntity.emit()
  }

}

